import { boot } from 'quasar/wrappers';
import { AxiosInstance } from 'axios';
import startUp from 'SharedDir/backend/axios/start-up';
import { useAppStore } from 'stores/app';

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $axios: AxiosInstance;
  }
}

export default boot((context) =>
  startUp(context, (redirectTo: string) => {
    const appStore = useAppStore();
    setTimeout(() => {
      appStore.showAuthDialog();
    }, 200);
    return {
      name: 'main',
      query: {
        redirectTo,
      },
    };
  })
);
